// extracted by mini-css-extract-plugin
module.exports = {"link":"Logo_link__35nVx","logo":"Logo_logo__nWOdp","text":"Logo_text__1d1AA"};